export enum PayflowPaymentMethodEnum {
  creditCard = 'C',
  automatedClearingHouseACH = 'A',
  pinlessDebit = 'D',
  telecheck = 'K',
  paypal = 'P'
}
